import { Component, Input, OnInit } from '@angular/core';
import { VariableCrudManagerService, BaseVariableService, VariablesTemplateComponent } from '@wms/variables';
import { CommonModule } from '@angular/common';
import { BaseComponent } from '@wms/app/components';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@Component({
  standalone: true,
  selector: 'wms-securityservice-var-creation',
  templateUrl: './securityservice-var-creation.component.html',
  styleUrls: [],
  imports: [CommonModule, TooltipModule, VariablesTemplateComponent]
})
export class SecurityserviceVarCreationComponent extends BaseComponent implements OnInit {

  @Input() selectedVarService: any;

  constructor(public varManagerService: VariableCrudManagerService, public baseVariableService: BaseVariableService) {
    super();
   }

  ngOnInit(): void {
  }

  handleModelChange(changeObj: any) {
    this.baseVariableService.selectedVariable.propertyObj[changeObj.propertyName].modelObj[this.baseVariableService.selectedVariable.propertyObj[changeObj.propertyName].modelKey] = changeObj.$event;  
    this.selectedVarService.__onPropertyChange(changeObj.propertyName, changeObj.$event);
  }

}
